
import {SystemConfig} from "../common/type-state";


export enum APIHosts {
    Identity = 'hostIdentity',
    Stream = 'hostStream',
    File = 'hostFile',
    Conversion = 'hostConversion',
    Bim = 'hostBim',
    DOCAI = 'hostDOCAI'
}

export class ApiReduxHelpers {
    config = { } as SystemConfig;
    getHost = (apiHost: APIHosts):string => {
        console.log("Getting API host for:", apiHost);
        console.log("Setting API config:", this.config);
        if (!this.config[apiHost]) {
            return ""
        }

        return this.config[apiHost]
    }
    setConfig = (config: SystemConfig):this => {
        
        this.config=config;
        return this;
    }
}
